import { type FunctionComponent, useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';

import type { JobItemDetails } from '../../api/use-job-item-details';
import { Container, Text, TextContainer, variants, WarningSpinner } from './notification-bar-styled';

export const GeneratingNotification: FunctionComponent<{ readonly item: JobItemDetails }> = ({ item }) => {
    const { translate } = useContext(ApplicationContext);

    return (
        <Container key="generating" animate={variants.animate} exit={variants.exit} initial={variants.initial}>
            <WarningSpinner />
            <TextContainer style={{ alignContent: 'center', minHeight: '30px' }}>
                <Text>
                    {translate('pages.job-architecture-v2.job-profile-generating-notification', {
                        jobType:
                            item.type === 'job-role'
                                ? translate('pages.job-architecture-v2.job-role')
                                : translate('pages.job-architecture-v2.job-level'),
                    })}
                </Text>
            </TextContainer>
        </Container>
    );
};
